import React from 'react';
import { connect } from 'react-redux';
import FormularioBiseccion from './FormularioBiseccion';
import PlotBiseccion from './PlotBiseccion';
import Table from './Table';

class BiseccionApp extends React.Component {


    render() {
        return (
            <div>
                <h1>The Bisection Method for root-finding</h1>
                <h5>Implementation for single variable function in <code>Python</code> with <code>sympy</code> and <code>plotly.js</code> for plotting.</h5>
                <div className="ui grid">
                    <div className="row">
                        <div className=" five wide column">
                            <FormularioBiseccion />
                        </div>
                        <PlotBiseccion datos={this.props} />
                    </div>
                    <div className="ui container">
                        <Table datos={this.props} />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        solution: state.solution_biseccion,
        form: state.form.datosBiseccion
    };
}


export default connect(mapStateToProps,)(BiseccionApp);